export enum Status {
  PUBLISH = 'Publish',
  UNPUBLISH = 'Unpublish'
}

export enum VerifiedStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive'
}

export enum SparePartStatuses {
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  NOT_APPROVED = 'Not Approved',
}

export enum ProfileStatus {
  INVITED = 'Invited',
  EXPIRED = 'Expired',
  PENDING = 'Pending',
  REJECTED = 'Rejected',
  RESUBMIT = 'Resubmission',
  REVOKED = 'Revoked',
  INCOMPLETE = 'Incomplete'
}

export enum RequestStatus {
  OPEN = 'Open',
  ASSIGNED = 'Assigned',
  SCHEDULED = 'Scheduled',
  PENDING = 'Pending',
  RESOLVED = 'Resolved',
  COMPLETED = 'Completed',
  CANCELLED = 'Cancelled'
}

export enum ActivityLogStatus {
  ONBOARDING = 'Onboarding',
  INVITATION = 'Invitation',
  PENDING = 'Pending',
  REJECTED = 'Rejected',
  RESUBMIT = 'Resubmission'
}

export enum Choice {
  YES = 'YES',
  NO = 'NO'
}

export enum Modes {
  ADD = 'add',
  EDIT = 'edit'
}

export enum FilterType {
  DATE = 'date-picker',
  MULTI_SELECT = 'muti-select-dropdown',
  SINGLE_SELECT = 'basic-dropdown',
  TEXT = 'text-field',
  NUMBER = 'number',
}

export const SUPPORTED_FORMATS = ['image/jpg',
  'image/jpeg',
  'application/pdf',
  'image/png'];

export const DummyImageKey = 'dummyKey';
export const validImageExtensions = ['jpg', 'jpeg', 'png', 'webp'];

export const typeOfFirms = ['Proprietorship', 'Partnership', 'Private Limited', 'LLP'];
export const docTypes = ['Aadhar Card', 'PAN Card', 'GST', 'Address Proof', 'Contract Copy', 'NOC Document'];

export const dayInMs = 60 * 60 * 24 * 1000;

export const gstValues = [0, 5, 12, 18, 28];

export enum PaymentStatus {
  CREATED = 'Created',
  VERIFIED = 'Verified',
  FAILED = 'Failed',
  CANCELLED = 'Cancelled',
  REFUNDED = 'Refunded',
  PAID = 'Paid',
  UNPAID = 'Unpaid',
}

export enum AddressType {
  HOME = 'Home',
  WORK = 'Work',
  OTHER = 'Other'
}

export enum EwasteStatus {
  OPEN = 'Open',
  SCHEDULED = 'Scheduled',
  PICKED = 'Picked Up',
  COMPLETED = 'Completed',
  CANCELLED = 'Cancelled'
}

export enum UserDeleteRequestStatus {
  OPEN = 'Open',
  REVOKE = 'Revoke',
  REVOKED = 'Revoked',
  DELETE = 'Delete',
  DELETED = 'Deleted'
}

export enum RewardTransactionStatus {
  COMPLETED = 'Completed',
  PENDING = 'Pending',
  CANCELLED = 'Cancelled',
  FAILED = 'Failed'
}
